// extracted by mini-css-extract-plugin
export default {"emoji":"ParentTopbar_emoji__dXQKl"};